var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5811 0.799805C14.573 0.800018 16.2 2.43095 16.2002 4.45605V4.54395C16.2 6.13031 15.1961 7.97414 13.7549 9.73926C12.5166 11.2559 11.0457 12.6054 9.9082 13.5264L9.44336 13.8936C9.18193 14.0928 8.85194 14.2002 8.5 14.2002C8.14198 14.2002 7.81241 14.0926 7.56055 13.8965L7.55664 13.8936C6.37858 12.9871 4.66009 11.4723 3.24512 9.73926C1.80394 7.97414 0.799981 6.13031 0.799805 4.54395V4.45605C0.800029 2.43095 2.42696 0.800018 4.41895 0.799805C5.57767 0.799805 6.67112 1.36105 7.35156 2.31055L7.35254 2.31152L7.85059 3.00488L8.5 3.90918L9.14941 3.00488L9.64746 2.31152L9.64844 2.31055C10.3289 1.36105 11.4223 0.799805 12.5811 0.799805Z",
    stroke: "#01152E",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIcon);
export default __webpack_public_path__ + "static/media/wishlist-icon.6fc49f67af4d2627a48aac764fdc0fa4.svg";
export { ForwardRef as ReactComponent };